import React from 'react';
import PubSub from 'pubsub-js';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { IcnGlobal } from '../BombasIcons';
import * as Styled from './CountryPickerLink.styled';
import { GET_USER_LOCALE } from '../App.gql';
import { mapCountryCode } from './CountryPickerLink.util';
import CountryFlag from './CountryFlag/CountryFlag';

const CountryPickerLink = ({ visualType = 'flag' }) => {
  const { data, loading } = useQuery(GET_USER_LOCALE);
  if (!data || loading) return null;

  const userLocale = data?.user?.locale;
  const countryCode = mapCountryCode(userLocale?.country) || 'US';

  const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
  const countryName = countryCode ? displayNames.of(countryCode) : '';

  if (!countryCode || !countryName) return null;

  return (
    <Styled.CountryPickerLink
      onClick={() => PubSub.publish('countries.open')}
      role="button"
    >
      {visualType === 'flag' ? (
        <CountryFlag countryCode={countryCode} data-testid="flag" />
      ) : (
        <IcnGlobal height={19} width={19} />
      )}
      <Styled.Name>{countryName}</Styled.Name>
    </Styled.CountryPickerLink>
  );
};

CountryPickerLink.propTypes = {
  /**
   * Determines the visual element to display: 'flag' for the country flag or 'globe' for the global icon.
   * @default 'flag'
   */
  visualType: PropTypes.oneOf(['flag', 'globe'])
};

export default CountryPickerLink;
